import { useState } from "react"
import { CustomerEntity } from "../../Objects/Customer/CustomerEntity"
import { PersonEntity } from "../../Objects/Person/PersonEntity"
import { ECustomerPaymentType } from "../../Enum/ECustomerPaymentType"
import { EOldType } from "../../Enum/EOldType"
import { EOrdenationType } from "../../Enum/EOrdenationType"

export const useCreateCustomer = () => {
  const [oldType, setOldType] = useState<EOldType>(EOldType.IsAdult)

  const [status, setStatus] = useState<ECustomerPaymentType>(ECustomerPaymentType.WithOutDebit)

  const [costumer, setCustomer] = useState<CustomerEntity | null>(null)

  const handleGenderChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setOldType(e.target.selectedIndex as EOrdenationType)
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setStatus(e.target.selectedIndex as ECustomerPaymentType)
  const handleInitialValue = (customer: CustomerEntity | null | undefined) => {
    if (customer) {
      setCustomer(customer)
    }
  }

  const handleSubmitForm = (personEntity: PersonEntity) => {
    return new CustomerEntity({
      status: status,
      id: costumer?.id || -1,
      personEntity: personEntity,
      oldType: oldType,
    })
  }

  return {
    status,
    handleStatusChange,
    handleGenderChange,
    handleInitialValue,
    handleSubmitForm,
  }
}
